import React from "react";
import styles from "./GeneralInfoCard.module.css";
import { BsFillInfoCircleFill } from "react-icons/bs";
import { CgNotes } from "react-icons/cg";
import { LuUsers } from "react-icons/lu";

// example cardData
// const cardData = {
//   owner: "Ryan",
//   startDate: "01/01/2021",
//   endDate: "01/01/2022",
//   memberCount: 5,
//   paperCount: 10,
//   totalBudget: 100000,
//   workStreamCount: 3,
// };
const title = (
  <div className="d-flex align-items-center gap-3 mb-4">
    <BsFillInfoCircleFill size={22}  />
    <h4 className={`${styles.title}   mb-0`}>
      General Info
    </h4>
  </div>
);

function GeneralProjectInfoCard({ cardData, className }) {
  return (
    <div className={`${styles.container} px-4 pt-5 rounded-4 ${className}`}>
      {/* title */}
      {title}

      <div className="d-flex flex-column flex-lg-row align-items-stretch">
        {/* main info card */}
        <div className={`${styles.infoCardMain} w-100 text-center rounded-4 p-5 mb-3 mb-lg-0`}>
          <h5 className="mb-3  text-capitalize">
            Owner : {cardData.owner}
          </h5>
          <div className="d-sm-flex gap-3 justify-content-center align-items-center">
            <div className="p3">
              Start Date: <span className="fw-bold">{cardData.startDate}</span>
            </div>
            <div className="d-none d-sm-block ">|</div>
            <div className="p3">End Date: <span className="fw-bold">{cardData.endDate}</span></div>
          </div>
        </div>

        {/* cards section */}
        <div className="row row-cols-auto justify-content-center w-100 gap-3 mx-2">
          {!isNaN(Number(cardData?.workStreamCount)) && (
            <ProjectItemCard
              title="WorkStreams"
              count={cardData?.workStreamCount}
            />
          )}
          <ProjectItemCard title="Members" count={cardData.memberCount} />
          <ProjectItemCard title="Papers" count={cardData.paperCount} />
          {cardData?.totalBudget && (
            <ProjectItemCard
              title="Total Budget"
              className="col-auto"
              count={cardData?.totalBudget}
            />
          )}
        </div>
      </div>

    </div>
  );
}

export default GeneralProjectInfoCard;

// variation: workStream
export function GeneralWorkStreamInfoCard({ cardData, className }) {
  return (
    <div className={`${styles.container} p-4 rounded-4 ${className}`}>
      {/* title */}
      {title}

      {/* main info card */}
      <div className="row justify-content-center w-100 gap-3">
        <div
          style={{minWidth: '500px' , maxWidth: '600px'}}
          className={`${styles.infoCardMain} text-center rounded-4 p-4 mb-3 mb-lg-0 col`}
        >
          <h5 className="mb-3 text-capitalize">
            Owner : {cardData.owner}
          </h5>
          <div className="d-sm-flex gap-3 justify-content-center align-items-center">
            <div className="p3">
              Start Date: <span className="fw-bold">{cardData.startDate}</span>
            </div>
            <div className=" d-none d-sm-block">|</div>
            <div className="p3 ">End Date: <span className="fw-bold">{cardData.endDate}</span></div>
          </div>
        </div>

        <div className={`d-flex justify-content-center gap-3 col-auto`}>
          {/* members */}
          <WorkStreamItemCard
            title="Members"
            count={cardData.memberCount}
            icon={<LuUsers size={25}  />}
          />
             
          {/* papers */}
          <WorkStreamItemCard
            title="Papers"
            count={cardData.paperCount}
            icon={<CgNotes size={25}  />}
          />
        </div>
      </div>
    </div>
  );
}

// variation: project
const ProjectItemCard = ({ title, count, className }) => {
  return (
    <div
      className={`${styles.infoCardSub} d-flex align-items-center justify-content-center rounded-4 p-3 p-ms-2 ${className}`}
    >
      <div className="p3">
        {title} : <span className="fw-bold">{count}</span>
      </div>
    </div>
  );
};

// variation: workStream
const WorkStreamItemCard = ({ title, count, icon }) => {
  return (
    <div className={`${styles.infoCardSub}  rounded-4 p-4 mx-ms-1  `}>
      <div className="p3 ">{title}</div>
      <div className="d-flex gap-4 justify-content-between align-items-center">
        <h5 className="">{count}</h5>
        <div className={`${styles.iconShadow} p-3 rounded-4`}>
          {icon}{" "}
        </div>
      </div>
    </div>
  );
};